import React from "react";

/**
 * Official Truly Nolen El Salvador logo (mascot + wordmark).
 * The PNG itself carries the full identity (mouse outline + "TRULY NOLEN" + tagline),
 * so we render it cleanly without extra side text.
 *
 * Props:
 *   - size: vertical height in px (default 40)
 *   - light: render on a dark surface (no-op; logo has its own background)
 *   - withSubtitle: if true, show small "TRULY 360" subtitle (to identify the app)
 */
export const BrandLogo = ({ size = 40, light = false, withSubtitle = true, className = "" }) => {
    // Scale subtitle typography with the logo size so big logos get a proportional label
    const subtitleSize = Math.max(9, Math.round(size * 0.12));
    const subtitlePadding = Math.max(8, Math.round(size * 0.12));
    return (
        <div className={`flex items-center gap-3 select-none ${className}`} data-testid="brand-logo">
            <img
                src="/trulyn-logo.png"
                alt="Truly Nolen - Control de Plagas y Termitas"
                style={{
                    height: size,
                    width: "auto",
                    objectFit: "contain",
                    display: "block",
                }}
                draggable={false}
            />
            {withSubtitle && (
                <div
                    className="leading-tight border-l"
                    style={{
                        borderColor: light ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.15)",
                        paddingLeft: subtitlePadding,
                    }}
                >
                    <div
                        className={`uppercase font-semibold ${light ? "text-white/85" : "text-black/75"}`}
                        style={{
                            fontFamily: "'Space Grotesk', sans-serif",
                            fontSize: subtitleSize,
                            letterSpacing: "0.22em",
                        }}
                    >
                        Truly
                    </div>
                    <div
                        className="uppercase font-semibold"
                        style={{
                            fontFamily: "'Space Grotesk', sans-serif",
                            fontSize: subtitleSize,
                            letterSpacing: "0.22em",
                        }}
                    >
                        <span className="text-[#FF0000]">IA</span>
                        <span className={light ? "text-[#FFD62B]" : "text-[#FFD62B]"}>360</span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BrandLogo;
